import styled from 'styled-components';

export const SchedulePickerWrapper = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: ${({ theme }) => theme.spacing.large};
`;

export const SchedulePickerRowWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: ${({ theme }) => theme.spacing.small};
`;

export const SchedulePickerFieldsWrapper = styled.div`
	display: flex;
	flex-direction: row;
	gap: ${({ theme }) => theme.spacing.xs};
	align-items: flex-start;
	width: 100%;
`;

export const SchedulePickerDateWrapper = styled.div`
	flex: 0 0 calc(50% - ${({ theme }) => theme.spacing.xs});
`;
